export default __webpack_public_path__ + "static/media/sms.13d3602b.svg";